import React from 'react'
import TimeManagement from './TestTaking/TimeManagement'
import Pacing from './TestTaking/Pacing'
import sampleTestTaking from '../../../helpers/assessment/sampleTestTaking'
import Stamina from './TestTaking/Stamina'
import NoBlanks from './TestTaking/NoBlanks'
import ProcessOfElimination from './TestTaking/ProcessOfElimination'
import Precision from './TestTaking/Precision'
import Motivation from './TestTaking/Motivation'
import getTestTakingData from '../../../helpers/assessment/getTestTakingData';

export default function TestTakingPage ({score, assessmentSubtests, headerText, userAssessment, studentScoring, testTakingData}) {
  
  const { byItem } = score
  // const testTakingData = getTestTakingData(score, userAssessment, studentScoring)
  return (
    <div className="new-page vertical-content test-taking-skills">
      <section className="page-header">
        <h3 className="page-title">Test-Taking Skills</h3>
        <h3 className="school-class-info">{headerText}</h3>
      </section>
      <TimeManagement 
        data={testTakingData.timeManagement}
      />
      <Pacing
        stars={testTakingData.pacing.stars}
        byItem={byItem}
        assessmentSubtests={assessmentSubtests}
      />
      <Stamina
        stars={testTakingData.stamina.stars}
        byItem={byItem}
        assessmentSubtests={assessmentSubtests}
      />
      <NoBlanks
        stars={testTakingData.noBlanks.stars}
        percents={testTakingData.noBlanks.percents}
      />
      <ProcessOfElimination
        stars={testTakingData.processOfElimination.stars}
        eliminations={testTakingData.processOfElimination.eliminations}
      />
      <Precision
        stars={testTakingData.precision.stars}
        preciseItems={testTakingData.precision.preciseItems}
        byItem={byItem}
        assessmentSubtests={assessmentSubtests}
      />
      <Motivation
        stars={testTakingData.motivation.stars}
        byItem={byItem}
        assessmentSubtests={assessmentSubtests}
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTakingPage.js